import { render, staticRenderFns } from "./DispatchDrivers.vue?vue&type=template&id=1d0f2bcb&scoped=true"
import script from "./DispatchDrivers.vue?vue&type=script&lang=js"
export * from "./DispatchDrivers.vue?vue&type=script&lang=js"
import style0 from "./DispatchDrivers.vue?vue&type=style&index=0&id=1d0f2bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0f2bcb",
  null
  
)

export default component.exports